import { render, staticRenderFns } from "./EmptyTable.vue?vue&type=template&id=cc1563ac"
import script from "./EmptyTable.vue?vue&type=script&lang=js"
export * from "./EmptyTable.vue?vue&type=script&lang=js"
import style0 from "./EmptyTable.vue?vue&type=style&index=0&id=cc1563ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports